import { MaterialUnit } from "fe-shared/src/types/domain";
import { InvoiceMaterialRaw } from "../types";

export const mapMaterialsWithUnits = (materials: InvoiceMaterialRaw[]) =>
  materials.map(({ weight, ...others }: InvoiceMaterialRaw) => ({
    ...others,
    units: {
      unit: MaterialUnit.Kg,
      unitQuantity: weight,
    },
  }));

export default mapMaterialsWithUnits;
